import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { Grid, Link } from '@mui/material';
import MediumTypography from '../components/formlib/MediumTypography';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';

export default function AppFooter() {
  const intl = useIntl();

  const getCopyRightMessage = () => {
    return `© ${dayjs().year()} ${intl.formatMessage({
      id: 'copyrightMessage',
      defaultMessage: 'Thom Child and Family Services All Rights Reserved',
    })}`;
  };

  return (
    <Box className="mainfooter" justifyContent="center" alignItems="center">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        alignContent="center"
        sx={{
          justifyContent: 'center',
          alignContent: 'center',
          paddingTop: '0px',
        }}
      >
        <Grid item lg={6}>
          <List
            className="submainfooter"
            style={{
              display: 'flex', // Changed from inline-flex to flex
              alignItems: 'center', // Vertically centers the list items
              justifyContent: 'flex-start', // Aligns items from the start
              height: '36px',
              width: '25%',
              color: '#536B6A',
              fontSize: '12px',
              fontWeight: '400',
              lineHeight: '14.5px',
              margin: 0, // Reset default margins
              padding: 0, // Reset default padding
            }}
          >
            <ListItem
              style={{
                padding: '0 8px 0 16px', // Add some horizontal spacing between items
                margin: 0, // Reset margins
                height: '100%', // Take full height of parent
                display: 'flex',
                alignItems: 'center', // Center content vertically
              }}
            >
              <Link
                href="https://www.thomchild.org/about-thom-child-family-services/"
                underline="none"
                title="Click to visit About Us page"
                target="_blank"
              >
                About Us
              </Link>
            </ListItem>
            <ListItem style={{ display: 'none' }}>
              <Link href="#" underline="none" title="Click to visit Terms page">
                Terms
              </Link>
            </ListItem>
            <ListItem style={{ display: 'none' }}>
              <Link
                href="#"
                underline="none"
                title="Click to visit Policy page"
              >
                Policy
              </Link>
            </ListItem>
            <ListItem
              style={{
                padding: '0 0px', // Add some horizontal spacing between items
                margin: 0, // Reset margins
                height: '100%', // Take full height of parent
                display: 'flex',
                alignItems: 'center', // Center content vertically
              }}
            >
              <Link
                href="https://www.thomchild.org/contact-thom/"
                underline="none"
                title="Click to visit Contact Us page"
                target="_blank"
              >
                Contact Us
              </Link>
            </ListItem>
          </List>
        </Grid>
        <Grid item lg={6}>
          <Box
            justifyContent="center"
            sx={{
              textAlign: 'right',
            }}
          >
            <MediumTypography
              sxProps={{
                color: '#536B6A',
                fontSize: '12px',
                fontWeight: '400',
                lineHeight: '14.5px',
                paddingRight: '30px',
                '&:hover': {
                  color: '#008c82',
                },
              }}
              label={getCopyRightMessage()}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
